import "../../utils/tailwind.css";
import cx from "../../utils/tailwind-merge";

export default function Section(props) {
  const { className = "", children } = props;
  return (
    <div
      className={cx(
        "rounded-lg bg-[#fffbf4] mb-4 2xl:w-[85%] xl:w-[80%] lg:w-[77%] lg:mr-[2rem] lg:ml-[15rem] p-3",
        className)}>
      {children}
    </div>
  );
}
